import Glide from '@glidejs/glide'
import { monitorForChanges } from '../helpers/_observer-handler'

export const glideConfig = () => {
    const glide = new Glide('.glide', {
        type: 'slider',
        touchAngle: 45,
        focusAt: 0,
        startAt: 0,
        keyboard: true,
        gap: 0,
        rewind: false,
    })

    glide.mount()
}

export const glideSliderHandler = () => {
    const slidesContainer = document.querySelector('.glide__slides')
    const activeSlideImg = document.querySelector('.glide__slide.glide__slide--active img')
    const slideControls = document.querySelectorAll('.glide button.slider__arrow')

    monitorForChanges('.glide__slides', () => {
        const slideContent = document.querySelector('.glide__slide.glide__slide--active .slide-gallery-content')
        for (const slideControl of slideControls) {
            slideControl.style.top = `calc(50% - ${slideContent.clientHeight / 2}px)`
        }
    })

    monitorForChanges('.glide__slide.glide__slide--active', () => {
        const slideContent = document.querySelector('.glide__slide.glide__slide--active .slide-gallery-content')
        slidesContainer.style.height = `${activeSlideImg.clientHeight + slideContent.clientHeight}px`
    })
}
